import { Result } from "appworks/model/gameplay/records/results/result";
import { ResultBuilder } from "appworks/server/builders/result-builder";
import { Point } from "appworks/utils/geom/point";
import { PartnerConnect } from "partner-connect/partner-connect-manager";
import { FreespinWinResult } from "slotworks/model/gameplay/records/results/freespin-win-result";
import { ScatterResult } from "slotworks/model/gameplay/records/results/scatter-result";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { slotDefinition } from "slotworks/model/slot-definition";
import { ygg } from "ygg/ygg";

export interface ScatterData {
    positions: Point[];
    matches: number;
    symbol: string;
    freespins: number;
}

export class PartnerConnectScatterResultBuilder implements ResultBuilder {

    public filter(response: PartnerConnect.SpinResponseBet): boolean {
        return (
            (response?.eventdata?.baseGameState && response?.eventdata?.baseGameState?.numberOfFreeSpinsWon > 1) ||
            (response?.eventdata?.freeSpinState && response?.eventdata?.freeSpinState?.respinsTriggered > 1)
        );
    }

    public build(record: SpinRecord, response: PartnerConnect.SpinResponseBet): Result[] {
        const results: Result[] = [];

        const data: ScatterData = this.parseScatterData(response);

        const result = new ScatterResult();
        result.symbolType = slotDefinition.symbolDefinitions[ygg.symbolMap.get(data.symbol)].id;
        result.cashWon = 0;
        result.positions = data.positions;
        result.matches = data.matches;
        results.push(result);

        if (data.freespins > 0) {
            const freespins = new FreespinWinResult();
            freespins.cashWon = 0;
            freespins.freespinsWon = data.freespins;
            freespins.linkedResult = result;
            results.push(freespins);
        }

        return results;
    }

    protected parseScatterData(response: PartnerConnect.SpinResponseBet): ScatterData {
        const positions: Point[] = [];
        const scatterSymbols: Array<{ symbol: string, count: number }> = [];

        for (let x = 0; x < response.eventdata.finalBoard.length; x++) {
            for (let y = 0; y < response.eventdata.finalBoard[x].length; y++) {
                if (ygg.scatterSymbols.indexOf(response.eventdata.finalBoard[x][y]) >= 0) {
                    positions.push(new Point(x, y));
                    const index = scatterSymbols.findIndex((entry) => entry.symbol === response.eventdata.finalBoard[x][y]);
                    if (index === -1) {
                        scatterSymbols.push({ symbol: response.eventdata.finalBoard[x][y], count: 1 });
                    } else {
                        scatterSymbols[index].count++;
                    }
                }
            }
        }

        scatterSymbols.sort((a, b) => b.count - a.count);

        const symbol: string = scatterSymbols[0].symbol;
        const matches: number = positions.length;
        const freespins: number = response.eventdata.baseGameState?.numberOfFreeSpinsWon | response.eventdata.freeSpinState?.respinsTriggered;

        return { positions, matches, symbol, freespins };
    }
}

export const partnerConnectScatterResultBuilder = new PartnerConnectScatterResultBuilder();
